// extracted by mini-css-extract-plugin
export default {"root":"river-data-grid_root__9VALc"};